import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import api from "@/api/bill";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async getBills(params: any) {
    return api.getBills(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async cancelBill(params: any) {
    return api.cancelBill(params);
  }

  @Action
  async exportBills(params: any) {
    return api.exportBills(params);
  }

  @Action
  async exportBills1(params: any) {
    return api.exportBills1(params);
  }

  @Action
  async exportCheck(params: any) {
    return api.exportCheck(params);
  }

  @Action
  async getSettlementOrders(params: any) {
    return api.getSettlementBills(params);
  }

  @Action
  async getSettlementHuman(params: any) {
    return api.getSettlementHuman(params);
  }

  @Action
  async getSettlementSms(params: any) {
    return api.getSettlementSms(params);
  }

  @Action
  async getSettlementRecharge(params: any) {
    return api.getSettlementRecharge(params);
  }

  @Action
  async getPayChannels(params: any) {
    return api.getPayChannels(params);
  }

  @Action
  async compareSettlement(params: any) {
    return api.compareSettlement(params);
  }

  @Action
  async compareWithDatabase(params: any) {
    return api.compareWithDatabase(params);
  }

  @Action
  async phone(params: any) {
    return api.phone(params);
  }

  @Action
  async card(params: any) {
    return api.card(params);
  }

  @Action
  async exportcard(params: any) {
    return api.exportcard(params);
  }

  @Action
  async history(params: any) {
    return api.history(params);
  }

  @Action
  async overview(params: any) {
    return api.overview(params);
  }

  @Action
  async share(params: any) {
    return api.share(params);
  }

  @Action
  async discounts(params: any) {
    return api.discounts(params);
  }

  @Action
  async product(params: any) {
    return api.product(params);
  }

  @Action
  async reductions(params: any) {
    return api.reductions(params);
  }

  @Action
  async confirmWechatBill(params: any) {
    return api.confirmWechatBill(params);
  }

  @Action
  async denyWechatBill(params: any) {
    return api.denyWechatBill(params);
  }

  @Action
  async noticeWechatBill(params: any) {
    return api.noticeWechatBill(params);
  }

  @Action
  async multiWechatBill(params: any) {
    return api.multiWechatBill(params);
  }

  @Action
  async services(params: any) {
    return api.services(params);
  }

  @Action
  async serviceCancel(params: any) {
    return api.serviceCancel(params);
  }

  @Action
  async serviceRefund(params: any) {
    return api.serviceRefund(params);
  }

  @Action
  async taisamHistory(params: any) {
    return api.taisamHistory(params);
  }

  @Action
  async deposit(params: any) {
    return api.deposit(params);
  }

  @Action
  async reject(params: any) {
    return api.reject(params);
  }

  @Action
  async devops(params: any) {
    return api.devops(params);
  }

  @Action
  async bindstadium(params: any) {
    return api.bindstadium(params);
  }

}
